<div class="td-cnt-ext">
    <div class="td-cnt" [ngClass]="{'td-cnt-mobile' : isMobile}">
        <div class="td-cnt-title">
            <i class="fal fa-lock dialog-icon"></i>
            <span class="te-title">{{'enquiryBook.closeEnquiry' | translate}} {{enquiryNo}}</span>
        </div>
        <div class="td-cnt-body">
            <div class="td-col">
                <teiasoft-select style="width:100%" [labelText]="'enquiryBook.closureStatus' | translate"
                    [isRequired]="true" [isValid]="closureReasonIsValid" [optionsList]="closureReasons"
                    (onSelected)="onSelectedClosure($event)" [noMinWidth]="true"
                    [defaultValue]="closureReason"></teiasoft-select>
            </div>
            <div class="td-col" *ngIf="lostReasonRequired">
                <teiasoft-select style="width:100%" [labelText]="'enquiryBook.lostReason' | translate"
                    [isRequired]="lostReasonRequired" [disabled]="lostReasonDisabled" [isValid]="lostReasonIsValid"
                    [optionsList]="lostReasons" (onSelected)="onSelectedlostReason($event)" [noMinWidth]="true"
                    [defaultValue]="lostReason" [clearValue]="clearLostReason"></teiasoft-select>
            </div>
            <div class="td-col" *ngIf="closureReason == 'Won'">
                <teiasoft-select style="width:100%" [labelText]="'enquiryBook.salesOrganization' | translate"
                    [isRequired]="salesOrgRequired" [isValid]="salesOrgIsValid" [optionsList]="salesOrgs"
                    (onSelected)="onSelectedSalesOrg($event)" [noMinWidth]="true"
                    [defaultValue]="salesOrg"></teiasoft-select>
            </div>
            <div class="td-col" *ngIf="closureReason == 'Won'">
                <teiasoft-select style="width:100%" [labelText]="'enquiryBook.application' | translate"
                    [isRequired]="applicationRequired" [isValid]="applicationIsValid" [optionsList]="applications"
                    (onSelected)="onSelectedApplication($event)" [noMinWidth]="true"
                    [defaultValue]="application"></teiasoft-select>
            </div>
            <div class="td-col" *ngIf="closureReason == 'Won'">
                <teiasoft-select style="width:100%" [labelText]="'grid.SapPriceUom' | translate" [isRequired]="false"
                    [isValid]="true" [optionsList]="sapPriceTypeOptions" (onSelected)="onSelectedSapPriceType($event)"
                    [noMinWidth]="true" [defaultValue]="sapPriceTypeSelection"></teiasoft-select>
            </div>
            <div class="td-col" *ngIf="closureReason == 'Won'">
                <p *ngIf="showDummyCustomerWonWarning()" class="warning-message">{{
                    'enquiryBook.dummyCustomerWonWarning' | translate }}</p>

            </div>

        </div>
        <div *ngIf="closureReason == 'Won'  && items().length > 0" style="width: 100%;">
            <teiasoft-grid [title]="'booked-enquiry-item'" [gridDescription]="'enquiryBook.bookedItems' | translate"
                [autoCompleteId]="'order-ec-items'" [columnsToShow]="columnsToShowItemWithApplication"
                [dataSet]="items()" [customIcoCols]="customIcoCols" [calculatedCols]="calculatedCols"
                [showFooter]="false" [selectable]="true" [multiSelection]="true" [disableAllSelection]='false'
                [autoWidth]="true" [showEditIcon]="false" [dateFormat]="globals.dateFormat!"
                [dateTimeFormat]="globals.dateTimeFormat!" [sortable]="false" [enquiryNo]="enquiryNo!"
                [gridName]="'items'" (rowsSelected)="onRowSelection($event)" [selectedRows]="selectedItems"
                [customRenderers]="customRenderersToUse"
                [customHeaderRenderers]="customHeaderRenderersToUse"></teiasoft-grid>
        </div>
        <div class="td-cnt-btn" [ngClass]="{'td-cnt-btn-mobile' : isMobile}">
            <teiasoft-button (onClick)="onCloseEnquiryClick(true)" class="mr-5" *ngIf="closureReason == 'Won'"
                [disabled]="isSendToSapDisabled()" [text]="'enquiryBook.closeAndSendToSAPEnquiry' | translate"
                [theme]="theme" [isMobile]="isMobile"></teiasoft-button>
            <teiasoft-button (onClick)="onCloseEnquiryClick()" class="mr-5" [disabled]="isCloseActionDisabled()"
                [text]="'enquiryBook.closeEnquiry' | translate" [theme]="theme" [isMobile]="isMobile"></teiasoft-button>
            <teiasoft-button (onClick)="onCloseModalClick()" class="mr-5" [type]="'tb-cancel'"
                [text]="'commons.cancel' | translate" [isMobile]="isMobile"></teiasoft-button>
        </div>
    </div>
</div>

<ng-template #costHeaderCell let-column="column">
    <span>{{getCostColumnHeaderLabel(column)}}</span>
</ng-template>

<ng-template #costValueCell let-row let-column="column">
    <div class="extra-cost-row">
        <span>{{row[column] !== undefined && row[column] !== null && row[column] !== '' ? row[column].toFixed(2) :
            ''}}</span>
    </div>
</ng-template>

<ng-template #deliveryDateCell let-row>
    <div class="extra-cost-row">
        <span>{{getItemRowMinDeliveryDate(row)}}</span>
        <span *ngIf="getItemRowDeliveryDatesCollection(row).length > 1">*</span>
        <div *ngIf="getItemRowDeliveryDatesCollection(row).length > 1" class="extra-cost-ico-cell">
            <i (click)="onItemDeliveryDatesClick(row)" class="extra-cost-icon fal fa-magnifying-glass"></i>
        </div>
    </div>
</ng-template>

<ng-template #materialCodeCell let-row let-column="column">
    <div class="input-cell">
        <input type="text" [value]="row[column] || ''" (input)="onMaterialCodeInput($event, row)">
    </div>
</ng-template>

<ng-template #sapItemNoCell let-row let-column="column">
    <div class="input-cell">
        <input type="number" step="1" min="0" [value]="row[column] ?? ''" (input)="onSapItemNoInput($event, row)">
    </div>
</ng-template>

<ng-template #sapPriceUomCell let-row>
    <div class="select-cell">
        <select class="grid-select" [value]="row.sapPriceType ?? ''" (change)="onSapPriceTypeChange($event, row)">
            <option value=""></option>
            <option *ngFor="let option of getSapPriceOptions(row)" [value]="option.value"
                [selected]="option.value === row.sapPriceType">{{option.text}}</option>
        </select>
    </div>
</ng-template>

<ng-template #sapPriceCell let-row>
    <div class="extra-cost-row">
        <span>{{row.sapPrice !== undefined && row.sapPrice !== null && row.sapPrice !== '' ? row.sapPrice.toFixed(2) :
            ''}}</span>
    </div>
</ng-template>

<ng-template #applicationCell let-row let-column="column">
    <div class="select-cell">
        <select class="grid-select" [value]="row[column] ?? ''" (change)="onApplicationSelectChange($event, row)">
            <option value=""></option>
            <option *ngFor="let app of applications" [value]="app.value">{{app.text}}</option>
        </select>
    </div>
</ng-template>

<ng-template #sapDeliveryDateCell let-row let-column="column">
    <div class="sap-delivery-date-cell">
        <teiasoft-datetime [value]="row[column] !== undefined && row[column] !== null && row[column] !== '' ? row[column].toString() : ''"
            [type]="'date'" [isRequired]="false" [disabled]="false" [isValid]="true" [noMargin]="true"
            [noMinWidth]="true" [dateFormat]="globals.dateFormat!" (onChange)="onSapDeliveryDateChange($event, row)" [size]="'s'">
        </teiasoft-datetime>
        <i *ngIf="hasMultipleDeliveryDatesForSap(row)" class="fas fa-triangle-exclamation sap-delivery-date-warning"
            [matTooltip]="getSapDeliveryDateWarningTooltip()"></i>
    </div>
</ng-template>

<app-modal-item-delivery-dates *ngIf="showItemDeliveryDates" (onCancel)="showItemDeliveryDates = false"
    [enquiryNo]="enquiryNo" [item]="selectedDeliveryDatesItem!">
</app-modal-item-delivery-dates>
